import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Link } from 'react-router-dom';
import DomoticNavbar from '../Components/Navbar';
import "../Components/navbar.css";
import "./pos.css";
import pos1 from "./img-domotic/sistemasPOS.png";
import pos2 from "./img-domotic/sistemas_POS2.png";
import pos3 from "./img-domotic/sistemas_POS2.png";

import toast from "./img-domotic/sistemas_POS2.png";
import square from "./img-domotic/sistemas_POS2.png";
import clover from "./img-domotic/sistemas_POS2.png";
import shopify from "./img-domotic/sistemas_POS2.png";

const SistemasPOS = () => {
  const [showMenu, setShowMenu] = useState(false);

  // Datos específicos para Sistemas POS
  const imagenesGaleria = [
    { src: pos1, alt: "Sistema POS para retail", caption: "Solución completa para comercios minoristas" },
    { src: pos2, alt: "POS con múltiples terminales", caption: "Configuraciones multi-caja" },
  ];

  const servicios = [
    {
      icon: "🛒",
      titulo: "POS para Retail",
      descripcion: "Sistemas completos para comercios minoristas con gestión de inventario y reportes avanzados.",
      features: ["Checkout rápido", "Control de inventario", "Reportes de ventas"]
    },
    {
      icon: "🍽️",
      titulo: "POS para Restaurantes",
      descripcion: "Soluciones especializadas para food service con gestión de mesas, cocina y delivery.",
      features: ["Módulo de meseros", "Envío a cocina", "Integración con delivery"]
    },
    {
      icon: "💳",
      titulo: "Procesamiento de Pagos",
      descripcion: "Integración con múltiples procesadores de pagos y terminales POS para todas las necesidades.",
      features: ["Tarjetas de crédito", "Pagos móviles", "Facturación electrónica"]
    },
    {
      icon: "📊",
      titulo: "Analítica Comercial",
      descripcion: "Herramientas avanzadas para análisis de ventas, inventario y comportamiento del cliente.",
      features: ["Dashboards interactivos", "Reportes personalizados", "Pronósticos de ventas"]
    }
  ];

  const tiposSoluciones = [
    {
      categoria: "Sistemas POS",
      items: [
        "POS para retail",
        "POS para restaurantes",
        "POS móviles",
        "Kioskos de autoservicio"
      ]
    },
    {
      categoria: "Hardware",
      items: [
        "Terminales POS",
        "Impresoras fiscales",
        "Lectores de código de barras",
        "Cajones de dinero"
      ]
    },
    {
      categoria: "Integraciones",
      items: [
        "Procesamiento de pagos",
        "Plataformas de eCommerce",
        "Sistemas de contabilidad",
        "Programas de lealtad"
      ]
    }
  ];

  const marcas = [
    { nombre: "Toast", logo: toast },
    { nombre: "Square", logo: square },
    { nombre: "Clover", logo: clover },
    { nombre: "Shopify POS", logo: shopify },
    { nombre: "Lightspeed", logo: "/marcas/lightspeed.png" },
    { nombre: "Vend", logo: "/marcas/vend.png" }
  ];

  // Efecto de scroll reveal
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.pos-scroll-reveal').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="pos-container">
      <DomoticNavbar/>
      
      {/* Hero Section */}
      <section className="pos-hero">
        <div className="pos-hero-content">
          <h1 className="pos-hero-title">Sistemas POS</h1>
          <p className="pos-hero-subtitle">
            Soluciones completas para la gestión de ventas
          </p>
        </div>
      </section>

      {/* Galería de Imágenes (lado a lado) */}
      <section className="pos-gallery pos-scroll-reveal">
        {imagenesGaleria.map((img, index) => (
          <div key={index} className="pos-gallery-item">
            <img 
              src={img.src} 
              alt={img.alt}
              className="pos-gallery-img"
            />
            <div className="pos-gallery-caption">
              <p>{img.caption}</p>
            </div>
          </div>
        ))}
      </section>

          {/* Sección de Características con Imágenes de Fondo */}
<section className="ryn-features-section">
  <div className="ryn-features-container">
    <h2 className="ryn-features-title">Nuestras Soluciones en Sistemas POS</h2>
    <p className="ryn-features-subtitle">Tecnología avanzada para la gestión de ventas y POS en general</p>
    
    <div className="ryn-features-grid">
      {/* Característica 1 */}
      <div className="ryn-feature-card">
        <div className="ryn-feature-content">
          <h3 className="ryn-feature-title">SISTEMAS POS</h3>
          <p className="ryn-feature-desc">Tecnología avanzada para la gestión de ventas.</p>
          <ul className="ryn-feature-list">
            <li>Terminales  y monitores para  POS: Táctiles, capacitivos</li>
            <li>Lectores de código de barras, impresoras y accesorios.</li>
            <li>Antenas Antihurto</li>
          </ul>
        </div>
      </div>
      
 
    </div>
  </div>
</section>  




      
    </div>
  );
};

export default SistemasPOS;